import getPresenceFromStore from '../presenceManager/getPresenceFromStore';
import getEmailAddressFromSipUri from '../presenceManager/getEmailAddressFromSipUri';
import { ChatRecipient } from '../store/schema/ChatViewState';
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';

export interface ChatRecipientsProps {
    recipients: ChatRecipient[];
}

@observer
export default class ChatRecipients extends React.Component<ChatRecipientsProps, {}> {
    render() {
        if (!this.props.recipients || this.props.recipients.length == 0) {
            return null;
        }

        return this.props.recipients.map(recipient => {
            return (
                <PersonaControl
                    emailAddress={getEmailAddressFromSipUri(recipient.sipUri)}
                    name={recipient.displayName}
                    size={PersonaSize.tiny}
                    presence={getPresenceFromStore(recipient.sipUri)}
                />
            );
        });
    }
}
